(function () {
  'use strict';
  if (window.Shopify && (window.Shopify.designMode || window.Shopify.previewThemeId)) return;
  var key = 'sl_ads_click_v1', ttl = 90 * 86400000;
  function allowed() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    return !!(cp && cp.marketingAllowed());
  }
  function update() {
    try {
      if (!window.Shopify || !window.Shopify.customerPrivacy) return null;
      if (!allowed()) { localStorage.removeItem(key); return null; }
      var params = new URLSearchParams(window.location.search);
      var click = params.get('gclid'), source = params.get('gclsrc');
      var record = JSON.parse(localStorage.getItem(key) || 'null');
      if (record && (!/^[A-Za-z0-9_-]{1,2048}$/.test(record.gclid || '') || !Number.isFinite(record.at) || record.at > Date.now() || Date.now() - record.at >= ttl)) record = null;
      if (click && /^[A-Za-z0-9_-]{1,2048}$/.test(click) && (!source || source.indexOf('aw') !== -1)) {
        if (!record || record.gclid !== click) {
          record = { gclid: click, at: Date.now() };
        }
      } else if (params.has('wbraid') || params.has('gbraid')) {
        record = null;
      }
      if (record) localStorage.setItem(key, JSON.stringify(record));
      else localStorage.removeItem(key);
      return record;
    } catch (error) { return null; }
  }
  window.slQualifiedAttribution = function () { return allowed() ? update() : (update(), null); };
  document.addEventListener('visitorConsentCollected', update);
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], function (error) { if (!error) update(); });
  }
  update();
})();
